// extracted by mini-css-extract-plugin
export var image = "_im-0";